import * as React from 'react';
import { flushSync } from 'react-dom';
import {
  Upload,
  type UploadProps,
} from 'antd';
import type { UploadRequestError, UploadRequestOption } from './interface';
import { uniqueId } from 'lodash-es';
import appStore from '@/stores';
import FmsStreamClient from '@winit/fms-stream-client';

interface FmsUploadType<Values = any> extends UploadProps<Values> {
  dragger?: boolean;
  data?: {
    locationName?: string;
    region?: 'CN' | 'AU' | 'EU' | 'US';
  },
}

const FmsUploadProps = {
  name: 'url',
  customRequest(option: UploadRequestOption) {
    const formData = new FormData();
    let optionData = {} as any;
    if (option.data) {
      optionData = {
        ...{
          locationName: appStore?.config?.fmsLocationName //默认fms上传目录
        },
        ...option.data
      };
      Object.keys(optionData).forEach(key => {
        const value = optionData?.[key];
        // support key-value array data
        if (Array.isArray(value)) {
          value.forEach(item => {
            formData.append(`${key}[]`, item);
          });
          return;
        }
        formData.append(key, value as string | Blob);
      });
    }

    // eslint-disable-next-line no-undef
    if (option.file instanceof Blob) {
      formData.append(option.filename as string, option.file, (option.file as any).name);
    } else {
      formData.append(option.filename as string, option.file);
    }
    let abort;
    FmsStreamClient.upload({
      file: option.file as File,
      locationName: optionData.locationName,
      region: optionData.region
    }).then((res: any) => {
      option.onSuccess?.({
        uid: uniqueId(),
        status: 'done',
        url: `${res?.objectURI}`,
      });
    }).catch((e: UploadRequestError | ProgressEvent<EventTarget>) => option.onError?.(e));
    return {
      abort,
    };
  },
  onPreview(file: any) {
    if (file.url) {
      window.open(file.url);
    }
  }
};

const FmsCloudUpload = (props: FmsUploadType) => {
  if (props?.dragger) {
    return (
      <Upload.Dragger {...FmsUploadProps}
        {...props}
        onChange={(info) => {
          flushSync(() => {
            props.onChange?.(info);
          });
        }}
      />
    );
  } else {
    return (
      <Upload {...FmsUploadProps}
        {...props}
        onChange={(info) => {
          flushSync(() => {
            props.onChange?.(info);
          });
        }}
      />
    );
  }
};

FmsCloudUpload.LIST_IGNORE = Upload.LIST_IGNORE;

export default FmsCloudUpload;
